import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import Users from './users'
import Transactions from './transactions'
import Loans from './loans'
import style from './tabs.module.scss'
import classNames from 'classnames'
import { InfiniteData } from 'react-query'
import { useParams } from 'react-router-dom'
import useGetTransactions from './hooks/useGetTransactions'
import useGetLoans from './hooks/useGetLoans'
import { useEffect, useState } from 'react'
interface ICustomTabsProps {
    data: InfiniteData<IGetMoneyPoolUsers>
    isLoading: boolean
    onWatchEnd: () => void
    shareValueAmount: number
    isManager: boolean
    setIsOpenPayToOtherModal: React.Dispatch<React.SetStateAction<boolean>>
    setSelectUser: React.Dispatch<
        React.SetStateAction<IMoneyPoolResults | undefined>
    >
    activeMemberCount: number
    transactionsCount: number
    loansCount: number
    setSearchUser: React.Dispatch<React.SetStateAction<string>>
    search: string
    setSearch: React.Dispatch<React.SetStateAction<string>>
    refetch: () => void
    hiddenLoans?: boolean
}
export default function CustomTabs({
    data,
    isLoading,
    onWatchEnd,
    shareValueAmount,
    isManager,
    setIsOpenPayToOtherModal,
    setSelectUser,
    activeMemberCount,
    transactionsCount,
    loansCount,
    setSearchUser,
    search,
    setSearch,
    refetch,
    hiddenLoans,
}: ICustomTabsProps) {
    const [searchTransaction, setSearchtransaction] = useState<string>(' ')
    const [searchTrans, setSearchTrans] = useState<string>(' ')
    const [searchLoans, setSearchLoans] = useState<string>(' ')
    const [searchLoan, setSearchLoan] = useState<string>(' ')
    const { id } = useParams()
    const { data: transactionData, isLoading: isLoadingTransactions } =
        useGetTransactions(id, searchTransaction)
    const {
        data: LoansData,
        isLoading: isLoadingLoans,
        fetchNextPage,
        isError,
    } = useGetLoans(id, searchLoans)

    useEffect(() => {
        if (searchTrans === '') {
            setSearchtransaction('')
        }
    }, [searchTrans])

    useEffect(() => {
        if (searchLoan === '') {
            setSearchLoans('')
        }
    }, [searchLoan])

    return (
        <>
            {data && (
                <Tabs
                    defaultActiveKey="home"
                    id="fill-tab-example"
                    className={classNames(
                        'mb-0.5 min-h-10 border-b border-[#EFEFEF]',
                        '[&_.nav-link]:!text-black [&_.nav-link]:!font-normal [&_.nav-link]:!border-0 [&_.nav-link]:!text-sm [&_.nav-link]:!min-h-10 [&_.nav-link]:!flex [&_.nav-link]:!items-center [&_.nav-link]:!justify-center',
                        '[&_.nav-link.active]:!text-black [&_.nav-link.active]:!font-normal [&_.nav-link.active]:!border-b-2 [&_.nav-link.active]:!border-green-1',
                        style.myTabs
                    )}
                    fill
                    variant="underline"
                >
                    <Tab eventKey="home" title={`اعضا (${activeMemberCount})`}>
                        <Users
                            data={data}
                            isLoading={isLoading}
                            onWatchEnd={onWatchEnd}
                            shareValueAmount={shareValueAmount}
                            isManager={isManager}
                            setIsOpenPayToOtherModal={setIsOpenPayToOtherModal}
                            setSelectUser={setSelectUser}
                            setSearchUser={setSearchUser}
                            setSearch={setSearch}
                            search={search}
                            refetch={refetch}
                        />
                    </Tab>
                    <Tab
                        eventKey="profile"
                        title={
                            transactionsCount
                                ? `تراکنش‌ها (${transactionsCount})`
                                : 'تراکنش ها'
                        }
                    >
                        <Transactions
                            data={transactionData}
                            isLoading={isLoadingTransactions}
                            isManager={isManager}
                            searchTrans={searchTrans}
                            setSearchtransaction={setSearchtransaction}
                            setSearchTrans={setSearchTrans}
                        />
                    </Tab>
                    <Tab
                        eventKey="longer-tab"
                        title={loansCount ? `وام‌ها (${loansCount})` : 'وام ها'}
                    >
                        <Loans
                            data={LoansData}
                            isLoading={isLoadingLoans}
                            fetchNextPage={fetchNextPage}
                            isError={isError}
                            setSearchLoans={setSearchLoans}
                            searchLoan={searchLoan}
                            setSearchLoan={setSearchLoan}
                            isManager={isManager}
                            isHiddenLoans={hiddenLoans}
                        />
                    </Tab>
                </Tabs>
            )}
        </>
    )
}
